import React from "react";
import graduate from "../../assets/png/graduate-cap.png";
import codefill from "../../assets/png/code-fill.png";
import userCurriculum from "../../assets/png/user-curriculum-solid.png";
import users from "../../assets/png/users-solid.png";
import HeroCard from "../../components/common/HeroCard";
import { motion } from "framer-motion";

const Offer = () => {
  const cardContents = [
    {
      id: 1,
      title: "Expert-led Courses",
      description:
        "Our instructors are seasoned data engineers from top tech companies. Gain practical, industry-relevant SQL, Python, and data systems development skills that hiring managers crave",
      image: graduate,
    },
    {
      id: 2,
      title: "1:1 Mentorship",
      description:
        "Get personal guidance from pros who’ve done it before—exclusive interview prep, CV reviews, partnerships with recruiting agencies, and live Q&A to help you stand out in interviews and on the job.",
      image: users,
    },
    {
      id: 3,
      title: "Hands-On Projects",
      description:
        "Build projects that simulate real enterprise data systems and architecture—showcase them to employers and skyrocket your confidence.",
      image: codefill,
    },
    {
      id: 4,
      title: "Cutting-Edge Curriculum",
      description:
        "Dive into advanced SQL, Data Modeling, Cloud Architecture, and new trends in real-time data processing—always up to date, always industry-approved.",
      image: userCurriculum,
    },
  ];

  return (
    <section className="py-16 px-4 max-w-7xl mx-auto">
      

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {cardContents.map((card, index) => (
          <HeroCard key={card.id} {...card} index={index} />
        ))}
      </div>
    </section>
  );
};

export default Offer;
